<dropzone class="dropzone-container"
          [config]="config"
          (addedFile)="onAddedfile($event)"
          (error)="onUploadError($event)">
</dropzone>
